import { useMemo, useState } from 'react';
import { RequestHeaderCard } from './RequestHeaderCard';
import { AddRequestCard } from './AddRequestCard';
import { RequestCard } from './RequestCard';
import { useIncidentResourceRequests } from 'components/IAP/hooks/incidentResourceRequestHooks';
import { selectUserGuid } from 'slices/commonSelectors';
import { useGetRosterForIncident } from 'hooks/incident/useRoster';
import { useSelector } from 'react-redux';

const ResourceRequestView = ({
  showAddResourceCard,
  setShowAddResourceCard,
  searchTerm,
}: {
  showAddResourceCard: boolean;
  setShowAddResourceCard: (show: boolean) => void;
  searchTerm: string;
}) => {
  const userGuid = useSelector(selectUserGuid);
  const { data: roster } = useGetRosterForIncident();
  const memberPositions =
    roster?.find((member) => member.userId === userGuid)?.incidentPositions ||
    [];

  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const { data: requests, isLoading, isError } = useIncidentResourceRequests();

  const filteredRequests = useMemo(() => {
    return requests
      ?.filter(
        (request) =>
          statusFilter.length === 0 || statusFilter.includes(request.status)
      )
      ?.filter((request) => {
        if (searchTerm === '') return true;
        return request.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
  }, [requests, statusFilter, searchTerm]);

  const reqCount = useMemo(() => {
    const counts: Record<string, number> = {};

    filteredRequests?.forEach((request) => {
      if (request.status === 'completed') {
        return;
      }
      request.logistics_items?.flat().forEach((item) => {
        if (item.resource_set_id) {
          counts[item.resource_set_id] =
            (counts[item.resource_set_id] || 0) + 1;
        }
      });
    });

    return counts;
  }, [filteredRequests]);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div className="text-danger">Failed to load items.</div>;

  return (
    <>
      <RequestHeaderCard setStatusFilter={setStatusFilter} />
      {showAddResourceCard && (
        <AddRequestCard setShowAddResourceCard={setShowAddResourceCard} />
      )}
      {filteredRequests?.map((request) => {
        return (
          <RequestCard
            key={request.id}
            request={request}
            memberPositions={memberPositions}
            reqCount={reqCount}
          />
        );
      })}
    </>
  );
};

export default ResourceRequestView;
